var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { headingVariants, headingIconVariants } from './Heading.css';
const renderIcon = (iconComponent, level) => {
    var _a;
    return React.cloneElement(iconComponent, {
        'aria-hidden': true,
        className: cx(headingIconVariants[level], iconComponent.props.className),
        weight: ((_a = iconComponent.props) === null || _a === void 0 ? void 0 : _a.weight) || (level === 4 ? 'bold' : 'regular'),
    });
};
export const Heading = React.forwardRef(function Heading(_a, ref) {
    var { as, children, className, iconPrefix, level = 1 } = _a, rest = __rest(_a, ["as", "children", "className", "iconPrefix", "level"]);
    const Component = as || `h${level}`;
    return (_jsxs(Component, Object.assign({}, rest, { className: cx(headingVariants[level], className), ref: ref, children: [iconPrefix && renderIcon(iconPrefix, level), _jsx("span", { children: children })] })));
});
